import styled from 'styled-components';

export const StyledHeaderMessage = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 34px;
    border-bottom: 1px solid #E6E3FC;
    padding: 10px;
    text-align: start;
    position: sticky;
    top: 0;
    margin-top: -80px;
    margin-bottom: 80px;
    width: 100%;
    background-color: white;
    z-index: 99;

    .app-btn {
        width: 136px;
        min-width: unset;
    }

    .close-btn {
        cursor: pointer;
        position: absolute;
        top: 10px;
        right: 20%;
    }

    @media screen and (max-width: 768px) {
        font-size: 14px;
        gap: 5px;
        padding: 15px 20px;

        .app-btn {
            flex-basis: 50%;
        }

        .close-btn {
            top: 3px;
            right: 2px;
        }
    }
`
